import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo9/poderlegislativo.png";
import Imagen2 from "../../../images/modulo9/presidentes.png";
import Imagen3 from "../../../images/modulo9/poderjudicial.png";
import Imagen4 from "../../../images/modulo9/gobiernosregionales.png";
import Imagen5 from "../../../images/modulo9/alcaldes.png";
import Imagen6 from "../../../images/modulo9/defensoria.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[0];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo9.content[0].activities[1].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[1].path}`,
    titlePrev: modulo9.title,
    linkPrev: modulo9.url,
  };
  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8 col-12">
          <p>
            <small className={`c-${modulo9.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
          <ul>
            <li>
              La Constitución no solo nos dice cuáles son nuestros deberes y
              derechos. También nos dice cómo está organizado el Estado peruano,
              es decir, quiénes se encargan de cada cosa en el gobierno de
              nuestro país.
            </li>
            <li>
              Estos son los componentes principales del Estado peruano. Observa
              y lee.
            </li>
          </ul>
        </div>
      </div>
      <div className="row gy-0">
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen1} alt="poderes" className="img-fluid" />
            <div className="text-center mt-4">
              El Poder Legislativo nos representa y hace las leyes.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen2} alt="poderes" className="img-fluid" />
            <div className="text-center">
              El Poder Ejecutivo gobierna el país y se ocupa de la salud, la
              vivienda, etcétera.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen3} alt="poderes" className="img-fluid" />
            <div className="text-center mt-4">
              El Poder Judicial resuelve conflictos.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen4} alt="poderes" className="img-fluid" />
            <div className="text-center mt-1">
              Los Gobiernos Regionales gobiernan en cada región o departamento.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen5} alt="poderes" className="img-fluid" />
            <div className="text-center mt-4 mb-1">
              Las Municipalidades gobiernan en pueblos y ciudades.
            </div>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <Card>
            <img src={Imagen6} alt="poderes" className="img-fluid" />
            <div className="text-center mt-1">
              También hay organismos autónomos como la Defensoría del Pueblo y
              el JNE.
            </div>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mt-4">
            <li>Ahora responde las siguientes preguntas.</li>
          </ul>
          <div className="ms-md-3 ms-0">
            <p>
              ¿En cuántos componentes principales se organiza el Estado peruano?
            </p>
            <textarea className="form-control mb-4" rows={3} />
            <p>¿Crees que todos son importantes? ¿Por qué?</p>
            <textarea className="form-control mb-4" rows={3} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y lean los textos. Luego,
          lean las preguntas y ayude a responderlas. Finalmente, señale que el
          Estado se organiza en 6 componentes. Destacan los 3 poderes, pero
          todas las partes son importantes pues cumplen distintas funciones.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
